<template>
  <v-container fluid class="white data-inline-content">
    <div class="qmkey-related-inline-table">
      <v-data-table
        :headers="columns"
        :items="current_qunit[props.attr]"
        item-key="uid"
        class="qmkey-explorer-table-expansion-table"
        dense
        sort-by="version"
        must-sort
        sort-desc
      >
        
      <template v-slot:[`item.date`]="{ item }">
        <span
          v-if="item.date"
        >
          {{
            new Date(item.date).toLocaleDateString(undefined, {
              // weekday: 'long',
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
            })
          }}
        </span>
      </template>      
      </v-data-table>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import FileIcons from '@/utils/fileicons';

export default {
  name: 'InlineBoxDownloadTracker',
  props: {
    current_qunit: Object,
    props: Object
  },
  data() {
    return {
      options: {
        sortBy: 'version',
      },
      selected: [],
      evidencesColumns: [
        {
          value: 'date',
          text: 'F. Descarga',
          sortable: true,
          sort: this.sortByDate
        },
        {
          value: 'version',
          text: 'Version',
          sortable: true,
        },
        {
          value: 'user',
          text: 'Usuario',
          sortable: true
        },
      ],
      files: FileIcons,
    }
  },

  computed: {
    columns() {
      return this.props && this.props.columns ? this.props.columns: this.evidencesColumns;
    },
  },

  methods: {
    sortByDate(a, b) {
      return new Date(a) - new Date(b);
    }    
  }
}
</script>


<style lang="scss">
@import '@/sass/explorer.scss';
</style>
